import { render, staticRenderFns } from "./setting_page.vue?vue&type=template&id=4088f452&"
import script from "./setting_page.vue?vue&type=script&lang=js&"
export * from "./setting_page.vue?vue&type=script&lang=js&"
import style0 from "./setting_page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports